<template>
    <DsModal
        ref="modal"
        dialog
        :is-open="isOpen"
        @close="close"
    >
        <div class="marketplace-modal">
            <h3 class="modalTitle">
                {{ $t('campaignsPage.bundles.marketplaceModal.title') }}
            </h3>
            <img src="@/assets/images/campaigns-installed.png" />
            <div class="body-links">
                <p v-html="$t('campaignsPage.bundles.marketplaceModal.body', { url: marketplaceUrl })" />
                <div class="buttons">
                    <DsFilledButton @click="goToMarketplace">
                        {{ $t('campaignsPage.bundles.marketplaceModal.marketplaceButton') }}
                    </DsFilledButton>

                    <DsTextButton class="secondary" @click="close">
                        {{ $t('campaignsPage.bundles.marketplaceModal.closeButton') }}
                    </DsTextButton>
                </div>
            </div>
        </div>
    </DsModal>
</template>

<script>

export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            marketplaceUrl: process.env.VUE_APP_MP_HISTORY_URL,
        };
    },

    methods: {
        close() {
            this.$emit('close');
        },

        goToMarketplace() {
            window.open(this.marketplaceUrl);
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .marketplace-modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;
        margin: $spacing-200 0;

        h3 {
            width: px-to-rem(250px);
            padding: $spacing-200;
            text-align: center;
        }

        img {
            margin-top: $spacing-200;
            margin-bottom: $spacing-400;
        }
    }

    .body-links {
        background-color: $color-gray-lightest;
        border-radius: px-to-rem(12px);
        padding: $spacing-400;
        margin-bottom: $spacing-200;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        button {
            margin: $spacing-100;
        }
    }

</style>
